/* eslint-disable */
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { debounceTime, finalize, map, takeUntil } from "rxjs/operators";
import { TenantServiceProxy } from "@api";

import { RangePickerState } from "./range-picker/range-picker-component.store";
import { StatsService } from "../lib/services/stats.service";

@Component({
    selector: "toolbar",
    templateUrl: "./toolbar.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent implements OnInit, OnDestroy {
    private _statsService = inject(StatsService);

    @Input()
    isLoading$!: Observable<boolean>;

    filterCtrl = new FormControl();
    tenants$ = new BehaviorSubject<any[]>([]);
    loading$ = new BehaviorSubject<boolean>(false);

    selectedTenant$ = this._statsService._tenant$;

    period$ = this._statsService.period$;

    private _unsubscribeAll = new Subject<void>();

    constructor(private _api: TenantServiceProxy) {}

    ngOnInit(): void {
        this.filterCtrl.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe((keyword) => {
            if (keyword) {
                this.loading$.next(true);
                this._statsService.selectTenant(null);
                this._api
                    .getAll(keyword, "name asc", 0, 1000)
                    .pipe(finalize(() => this.loading$.next(false)))
                    .subscribe((res) => this.tenants$.next(res.items));
            } else {
                this.tenants$.next([]);
            }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    periodStateChanged(state: RangePickerState): void {
        this._statsService.updatePeriod(state);
    }

    selectClient(client: any): void {
        this._statsService.selectTenant(client);
    }

    compareTenant(a: any, b: any): boolean {
        return !!a && !!b && a.id === b.id;
    }
}
